export default __webpack_public_path__ + "static/open-graph-4743081c728d41dbb36c11f1bad62cf2.png";